export const yemekler = {
  title: 'Yemekler',
  titleEN: 'Food',
  description: 'Onedio Yemek kategorisinde, yemeğin her alanına dair hem yazılı içerikler, hem de Onedio Yemek Youtube ve Instagram sayfalarında video içerikler ile marka ve ürüne özel videolar hazırlayarak, genel kabul görmüş yemek video hedef kitlesine alternatif olarak tüm hedef kitleler özelinde milyonlarca kullanıcıyla buluşuyoruz.',
  descriptionEN: 'In the Onedio Food category, we reach millions of users across all target audiences by creating written content covering all aspects of food, as well as videos on the Onedio Food YouTube and Instagram pages, including brand- and product-specific videos, as an alternative to the widely accepted food video target audience.',
  tabs: [
    {
      id: 1,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'PUBG\'de galibiyet aldıktan sonra ben 🍗',
          image: 'https://srv-cdn.onedio.com/store/8183d6e6ce21561b71b0aab545a3eb28819313732a9b0931b83bb0aa4e65d8e3.png',
          url: 'https://www.instagram.com/reel/CK_i96sJBk1/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'PUBG\'de galibiyet aldıktan sonra ben 🍗',
        },
        {
          id: 2,
          name: 'Makarna Cipsi',
          image: 'https://srv-cdn.onedio.com/store/53a40deafa98aaa3a9ea0e2141bb09e2549f41435f50666e460b8db0f5642bb8.png',
          url: 'https://www.instagram.com/reel/CUR4ITIMtq7/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Makarna Cipsi',
        }
      ]
    },
    {
      id: 2,
      title: 'Video Tarifleri',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'PUBG ile Nar Gibi Kızarmış Bütün Tavuk',
          image: 'https://srv-cdn.onedio.com/store/99bbd3b0af9c826f0a24523a34edb6cc8aef8dc1f81014a474d76f633b53266e.png',
          url: 'https://www.youtube.com/embed/33F00icP8K8?rel=0',
          modal: 'iframe',
          modalTitle: 'PUBG ile Nar Gibi Kızarmış Bütün Tavuk'
        },
        {
          id: 2,
          name: '4 Farklı Hindi Dolma Tarifi',
          image: 'https://srv-cdn.onedio.com/store/7556a7e5a7272e9a61b3853a2c2e38c0616474be3622a20af2fed9cce5b99962.png',
          url: 'https://www.youtube.com/embed/cIBJKNacni0?rel=0',
          modal: 'iframe',
          modalTitle: '4 Farklı Hindi Dolma Tarifi'
        },
        {
          id: 3,
          name: 'Sanayi Tostu vs Sosyete Tostu',
          image: 'https://srv-cdn.onedio.com/store/fdd46fbe48a3d48861792c9ce4ecc1aa56dcf4e2f35637c5a10e4fe8d9e37062.png',
          url: 'https://www.youtube.com/embed/dhpLf90m8Xg?rel=0',
          modal: 'iframe',
          modalTitle: 'Sanayi Tostu vs Sosyete Tostu'
        },
        {
          id: 4,
          name: '4 Farklı Makarna Sosu Tarifi',
          image: 'https://srv-cdn.onedio.com/store/3a6cb44c1d2d623828bbe9ef421c85c7f6f674cf6365523f5b2dd2acc751778b.png',
          url: 'https://www.youtube.com/embed/qKiYQo6FMxY?rel=0',
          modal: 'iframe',
          modalTitle: '4 Farklı Makarna Sosu Tarifi'
        }
      ]
    },
    {
      id: 3,
      title: 'Fon Format Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Uzak Doğu Yiyecekleri MUKBANG-Karantina',
          image: 'https://srv-cdn.onedio.com/store/454994f25211c4388a6a3a26657594bbcbe4d9e2710cd5df9c4c24ca456a0cfd.png',
          url: 'https://www.youtube.com/embed/QyxvHWxdHxQ?rel=0',
          modal: 'iframe',
          modalTitle: 'Uzak Doğu Yiyecekleri MUKBANG-Karantina'
        },
        {
          id: 2,
          name: 'İlk Buluşmada Yenmemesi Gereken Yiyecekler',
          image: 'https://srv-cdn.onedio.com/store/298d42727caeb824bad9294ba57566f170cca89ba0d8d5e426e0edc3cccc5a80.png',
          url: 'https://www.youtube.com/embed/aqQ8hVrTpjE?rel=0',
          modal: 'iframe',
          modalTitle: 'İlk Buluşmada Yenmemesi Gereken Yiyecekler'
        }
      ]
    },
  ],
  egTabs: [
    {
      id: 1,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Winner Winner Chicken Dinner in PUBG 🍗',
          image: 'https://srv-cdn.onedio.com/store/8183d6e6ce21561b71b0aab545a3eb28819313732a9b0931b83bb0aa4e65d8e3.png',
          url: 'https://www.instagram.com/reel/CK_i96sJBk1/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Winner Winner Chicken Dinner in PUBG 🍗',
        },
        {
          id: 2,
          name: 'Pasta Chips',
          image: 'https://srv-cdn.onedio.com/store/53a40deafa98aaa3a9ea0e2141bb09e2549f41435f50666e460b8db0f5642bb8.png',
          url: 'https://www.instagram.com/reel/CUR4ITIMtq7/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Pasta Chips',
        }
      ]
    },
    {
      id: 2,
      title: 'Video Recipes',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Whole Chicken Roasted Like Pomegranate with PUBG',
          image: 'https://srv-cdn.onedio.com/store/99bbd3b0af9c826f0a24523a34edb6cc8aef8dc1f81014a474d76f633b53266e.png',
          url: 'https://www.youtube.com/embed/33F00icP8K8?rel=0',
          modal: 'iframe',
          modalTitle: 'Whole Chicken Roasted Like Pomegranate with PUBG'
        },
        {
          id: 2,
          name: '4 Different Stuffed Turkey Recipes',
          image: 'https://srv-cdn.onedio.com/store/7556a7e5a7272e9a61b3853a2c2e38c0616474be3622a20af2fed9cce5b99962.png',
          url: 'https://www.youtube.com/embed/cIBJKNacni0?rel=0',
          modal: 'iframe',
          modalTitle: '4 Different Stuffed Turkey Recipes'
        },
        {
          id: 3,
          name: 'Industrial Toast vs Gourmet Toast',
          image: 'https://srv-cdn.onedio.com/store/fdd46fbe48a3d48861792c9ce4ecc1aa56dcf4e2f35637c5a10e4fe8d9e37062.png',
          url: 'https://www.youtube.com/embed/dhpLf90m8Xg?rel=0',
          modal: 'iframe',
          modalTitle: 'Industrial Toast vs Gourmet Toast'
        },
        {
          id: 4,
          name: '4 Different Pasta Sauce Recipes',
          image: 'https://srv-cdn.onedio.com/store/3a6cb44c1d2d623828bbe9ef421c85c7f6f674cf6365523f5b2dd2acc751778b.png',
          url: 'https://www.youtube.com/embed/qKiYQo6FMxY?rel=0',
          modal: 'iframe',
          modalTitle: '4 Different Pasta Sauce Recipes'
        }
      ]
    },
    {
      id: 3,
      title: 'Fancy Format Video',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Far East Foods MUKBANG-Quarantine',
          image: 'https://srv-cdn.onedio.com/store/454994f25211c4388a6a3a26657594bbcbe4d9e2710cd5df9c4c24ca456a0cfd.png',
          url: 'https://www.youtube.com/embed/QyxvHWxdHxQ?rel=0',
          modal: 'iframe',
          modalTitle: 'Far East Foods MUKBANG-Quarantine'
        },
        {
          id: 2,
          name: 'Foods Not to Eat on First Date',
          image: 'https://srv-cdn.onedio.com/store/298d42727caeb824bad9294ba57566f170cca89ba0d8d5e426e0edc3cccc5a80.png',
          url: 'https://www.youtube.com/embed/aqQ8hVrTpjE?rel=0',
          modal: 'iframe',
          modalTitle: 'Foods Not to Eat on First Date'
        }
      ]
    }

  ]
}

